import axios from "axios";
import { GetPriceRangeRequestPayload } from "./types";

export const getPrice = (query: GetPriceRangeRequestPayload) =>
  axios
    .get("/prices", {
      params: query,
    })
    .then((res) => res.data);
